export default __webpack_public_path__ + "static/media/CASALOGO-white-i.b385ba3b.svg";